// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-job-cate-menu[data-v-4be1c188]{display:flex;flex-direction:column;flex-wrap:wrap;overflow-x:scroll;padding-top:.25rem;height:282px}", ""]);
// Exports
module.exports = exports;
